// extracted by mini-css-extract-plugin
export var gridItems = "Item-module--gridItems--2ccf3";
export var grow = "Item-module--grow--985d4";
export var hidden = "Item-module--hidden--e2d6d";